import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import PropTypes from 'prop-types'
// Import images
const ExpertiesIcon={
    html5:'https://lh3.googleusercontent.com/d/1roLcDETUpMkadMKbM1grkTmiLUnjRhV6',
    css3:'https://lh3.googleusercontent.com/d/1nkxNNB77zixPHCfqTjXNS68pndY1Bs4x',
    javascript:'https://lh3.googleusercontent.com/d/1AUNpVLR6Az5qJOuj62q6LgwGYGqrPKKV',
    react:'https://lh3.googleusercontent.com/d/1C675dxZvw-r5lHkXbaeDGkNt-Qms9Lxj',
    nodeJs:'https://lh3.googleusercontent.com/d/1PkyWQI-iHfNoS78_Gt1V7gpn-2OoL7Yi',
    express:'https://lh3.googleusercontent.com/d/1WHbGOk5gFf5eMtE3sDnvpyOJ9iwy4Ta3',
    tailwind:'https://lh3.googleusercontent.com/d/1JCKjgHWUYu6x-L8AJi7P7mxAXJbn_RPn',
    figma:'https://lh3.googleusercontent.com/d/1Ih9GXU9H091eUjVos0RB3aXDufTbjtiQ',
    mongoDb:'https://lh3.googleusercontent.com/d/1xs18SLgXwQiJscRwDij8xuBQ0xILaz25',
    office:'https://lh3.googleusercontent.com/d/11PGV6PMgPeAh1elDGNLZFjOSh3mFlg3A',
    photoshop:'https://lh3.googleusercontent.com/d/1zGcwi3bQZO55jdj2NMWS-1wFKn01idyi',
    adobePremiere:'https://lh3.googleusercontent.com/d/1m3IbMW16DTClbElVqSx3CuopVNg40_SF'
}
const MyExpertise = ({ darkMode }) => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  const skillCategories = [
    {
      title: "Frontend Development",
      icon: "🎨",
      color: "from-blue-500 to-cyan-500",
      skills: [
        { name: "HTML5", image: ExpertiesIcon.html5, level: 95 },
        { name: "CSS3", image: ExpertiesIcon.css3, level: 90 },
        { name: "JavaScript", image: ExpertiesIcon.javascript, level: 88 },
        { name: "React", image: ExpertiesIcon.react, level: 85 },
        { name: "Tailwind CSS", image: ExpertiesIcon.tailwind, level: 92 },
      ]
    },
    {
      title: "Backend Development",
      icon: "⚙️",
      color: "from-green-500 to-emerald-500",
      skills: [
        { name: "Node.js", image: ExpertiesIcon.nodeJs, level: 82 },
        { name: "Express.js", image: ExpertiesIcon.express, level: 80 },
        { name: "MongoDB", image: ExpertiesIcon.mongoDb, level: 78 },
      ]
    },
    {
      title: "Design & Tools",
      icon: "🛠️",
      color: "from-purple-500 to-pink-500",
      skills: [
        { name: "Figma", image: ExpertiesIcon.figma, level: 85 },
        { name: "Photoshop", image: ExpertiesIcon.photoshop, level: 80 },
        { name: "Premiere Pro", image: ExpertiesIcon.adobePremiere, level: 75 },
        { name: "MS Office", image: ExpertiesIcon.office, level: 90 },
      ]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const categoryVariants = {
    hidden: { y: 30, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const skillVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 10,
      },
    },
  };

  return (
    <div className={`relative pb-10 px-1 overflow-hidden ${darkMode ? 'bg-gray-900' : 'bg-gradient-to-br from-gray-50 to-blue-50'}`} ref={ref}>
      {/* Background Elements */}
      <div className="absolute inset-0 -z-10">
        <div className={`absolute top-20 left-10 w-72 h-72 ${darkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'} rounded-full blur-3xl animate-pulse`}></div>
        <div className={`absolute bottom-20 right-10 w-96 h-96 ${darkMode ? 'bg-purple-500/10' : 'bg-purple-400/20'} rounded-full blur-3xl animate-pulse delay-1000`}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] ${darkMode ? 'bg-gradient-to-r from-blue-500/5 to-purple-500/5' : 'bg-gradient-to-r from-blue-100/30 to-purple-100/30'} rounded-full blur-3xl`}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <motion.div 
          className="text-center mb-16"
          initial={{ y: -30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : { y: -30, opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-1 ">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${
              darkMode ? 'bg-gradient-to-r from-blue-500 to-purple-500' : 'bg-gradient-to-r from-blue-400 to-purple-400'
            }`}>
              ⚡
            </div>
            <h2 className={`text-4xl py-2 lg:text-5xl font-bold ${
              darkMode 
                ? "bg-gradient-to-r from-white via-blue-200 to-purple-200 text-transparent bg-clip-text" 
                : "bg-gradient-to-r from-gray-900 via-blue-600 to-purple-600 text-transparent bg-clip-text"
            }`}>
              My Expertise
            </h2>
          </div>
          <p className={`text-md max-w-2xl mx-auto ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            A comprehensive overview of my technical skills and proficiency levels across different domains
          </p>
          <div className={`w-24 h-1 mx-auto rounded-full mt-3 ${
            darkMode ? "bg-gradient-to-r from-blue-500 to-purple-500" : "bg-gradient-to-r from-blue-400 to-purple-400"
          }`}></div>
        </motion.div>

        {/* Skills Categories */}
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {skillCategories.map((category, categoryIndex) => (
            <motion.div
              key={categoryIndex}
              variants={categoryVariants}
              className={`relative group ${darkMode ? 'bg-gray-800/50' : 'bg-white/70'} backdrop-blur-sm rounded-2xl px-2 py-6 border ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              } shadow-xl hover:shadow-2xl transition-all duration-500`}
            >
              {/* Category Header */}
              <div className="text-center mb-8">
                <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-r ${category.color} flex items-center justify-center text-3xl shadow-lg`}>
                  {category.icon}
                </div>
                <h3 className={`text-xl font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                  {category.title}
                </h3>
                <div className={`w-12 h-1 mx-auto rounded-full bg-gradient-to-r ${category.color}`}></div>
              </div>

              {/* Skills List */}
              <div className="space-y-1">
                {category.skills.map((skill, skillIndex) => (
                  <motion.div
                    key={skillIndex}
                    variants={skillVariants}
                    whileHover={{ scale: 1.02, x: 5 }}
                    className={`flex items-center justify-between p-4 rounded-xl transition-all duration-300 ${
                      darkMode 
                        ? 'bg-gray-700/50 hover:bg-gray-600/50' 
                        : 'bg-gray-50/50 hover:bg-white/50'
                    } group/skill`}
                  >
                    <div className="flex  items-center gap-4">
                      <div className={`w-12 h-12 p-2 rounded-lg ${
                        darkMode ? 'bg-gray-600' : 'bg-white'
                      } shadow-md group-hover/skill:shadow-lg transition-all duration-300`}>
                        <img
                          src={skill.image}
                          alt={skill.name}
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <div>
                        <h4 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                          {skill.name}
                        </h4>
                        <div className="flex items-center gap-2 mt-1">
                          <div className={`lg:w-[250px] w-44 h-2 rounded-full ${
                            darkMode ? 'bg-gray-600' : 'bg-gray-200'
                          } overflow-hidden`}>
                            <motion.div
                              className={`h-full bg-gradient-to-r ${category.color} rounded-full`}
                              initial={{ width: 0 }}
                              animate={inView ? { width: `${skill.level}%` } : { width: 0 }}
                              transition={{ duration: 1.5, delay: 0.5 + (skillIndex * 0.1) }}
                            />
                          </div>
                          <span className={`text-sm  font-medium ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                            {skill.level}%
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Skill Level Indicator */}
                    {/* <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                      skill.level >= 90 ? 'bg-green-100 text-green-800' :
                      skill.level >= 80 ? 'bg-blue-100 text-blue-800' :
                      skill.level >= 70 ? 'bg-yellow-100 text-yellow-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {skill.level >= 90 ? 'Expert' :
                       skill.level >= 80 ? 'Advanced' :
                       skill.level >= 70 ? 'Intermediate' : 'Beginner'}
                    </div> */}
                  </motion.div>
                ))}
              </div>

              {/* Hover Effect Overlay */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-r ${category.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
            </motion.div>
          ))}
        </motion.div>

        {/* Bottom CTA */}
        <motion.div 
          className="text-center mt-16"
          initial={{ y: 30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : { y: 30, opacity: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <p className={`text-lg mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Always learning and expanding my skill set
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {['Continuous Learning', 'Problem Solving', 'Team Collaboration', 'Adaptability'].map((trait, index) => (
              <span
                key={index}
                className={`px-4 py-2 rounded-full text-sm font-medium ${
                  darkMode 
                    ? 'bg-gray-700 text-gray-300 border border-gray-600' 
                    : 'bg-white text-gray-700 border border-gray-200'
                } shadow-md`}
              >
                {trait}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

MyExpertise.propTypes = {
  darkMode: PropTypes.bool.isRequired,
};

export default MyExpertise;
